const _excluded = ["value", "format", "textColor", "formatContent"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import PropTypes from 'prop-types';
import React from 'react';
import { computeHeightInPixels } from '../heightProps';
import Label from './label';
import entityComposition from '../../common/classes/entityComposition';
import { valueSelector } from '../selectors';
import { getFormatContent } from '../selectors/simpleSelectors';
const LabelView = _ref => {
  let {
      value,
      format,
      textColor = null,
      formatContent = null
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  const labelValue = formatContent || value;
  const height = computeHeightInPixels(_objectSpread({
    value,
    format,
    textColor,
    formatContent
  }, otherProps));
  const className = format.align ? `text-${format.align}` : '';
  return /*#__PURE__*/React.createElement(Label, {
    value: labelValue,
    className: `"t-lv ${className}`,
    style: {
      minHeight: height
    },
    color: textColor
  });
};
LabelView.propTypes = {
  /* eslint-disable react/forbid-prop-types */
  value: PropTypes.string.isRequired,
  formatContent: PropTypes.string,
  format: PropTypes.object.isRequired,
  textColor: PropTypes.shape({
    red: PropTypes.number,
    green: PropTypes.number,
    blue: PropTypes.number
  })
  /* eslint-enable react/forbid-prop-types */
};
export { LabelView as UncomposedLabelView };
export default entityComposition(LabelView, [], {
  value: valueSelector,
  formatContent: getFormatContent
});